var map = {
	"./icon-priority-1.svg": 1079,
	"./icon-priority-2.svg": 57956,
	"./icon-priority-3.svg": 12677,
	"./icon-priority-high.svg": 26650,
	"./icon-priority-low.svg": 39076,
	"./icon-priority-medium.svg": 87919,
	"./icon-priority-none.svg": 820,
	"./icon-priority.svg": 23253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76905;